
export const ShipmentListPublish = () => {
    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">출하 검색</h3>
                    <div className="filter_toolbar"></div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label for="" className="form-label frm_label">상태</label>
                            <select className="form-select">
                                <option>출하요청</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="frm_row">
                            <label for="" className="form-label frm_label">출하일자</label>
                            <div className="frm_field input_date">
                                <input type="date" className="form-control" />
                                <span className="txt_range">~</span>
                                <input type="date" className="form-control me-0" />
                                <button className="btn btn-info btn_search">
                                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">출하 목록(<span>13</span>건)</h6>
                    <div className="table_toolbar">
                        <button className="btn btn-outline-secondary w-150px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_import.png"} alt="" />엑셀 가져오기</button>
                        <button className="btn btn-dark w-150px px-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"} alt="" />엑셀 내보내기</button>

                        <button className="btn btn-info color3 w-80px ms-40px">미리보기</button>
                        <button className="btn btn-outline-primary w-110px px-0">출하요청 취소</button>
                        <button className="btn btn-primary w-80px">출하</button>
                        <button className="btn btn-primary color2 w-80px">이관</button>
                        <button className="btn btn-outline-info w-80px px-0">출하취소</button>
                        <button className="btn btn-outline-primary color2 w-80px">이관취소</button>
                        <button className="btn btn-outline-dark"><img src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"} alt="" />선택삭제</button>
                    </div>
                </div>

                <div className="table_scroll">
                    <table className="table table-bordered my_table">
                        <thead>
                            <tr>
                                <th rowSpan={2} style={{ width: "4.4%" }}>
                                    <div className="checkbox_outer">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                        />
                                    </div>
                                </th>
                                <th style={{ width: "8.8%" }}>수주일자</th>
                                <th style={{ width: "8.8%" }}>출하일자</th>
                                <th style={{ width: "11.32%" }}>수주유형</th>
                                <th style={{ width: "6.28%" }}>담당자</th>
                                <th style={{ width: "8.8%" }}>고객사</th>
                                <th style={{ width: "10.06%" }}>매출처</th>
                                <th style={{ width: "6.28%" }}>환종</th>
                                <th style={{ width: "8.8%" }}>금액</th>
                                <th>상태</th>
                                <th style={{ width: "11.32%" }}>ERP 수주계약 코드</th>
                                <th style={{ width: "8.8%" }}>마감일자</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((item, index) => (
                                <tr>
                                    <td style={{ width: "4.4%" }} className="text-center">
                                        <div className="checkbox_outer"><input
                                            className="form-check-input"
                                            type="checkbox"
                                        /></div>
                                    </td>
                                    <td className="text-center">2024.01.10</td>
                                    <td className="text-center">2024.01.10</td>
                                    <td className="text-center">로열티매출</td>
                                    <td className="text-center">홍길동</td>
                                    <td className="text-center">고객사</td>
                                    <td className="text-center">주식회사 구구구</td>
                                    <td className="text-center">KRW</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-center">출하 요청</td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="pagination-container">
                    <ul>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                                alt="First Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                                alt="Previous Page"
                                className=""
                            />
                        </li>
                        <li className="active">1</li>
                        <li className="">2</li>
                        <li className="">3</li>
                        <li className="">4</li>
                        <li className="">5</li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                                alt="Next Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                                alt="Last Page"
                                className=""
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
}